export function createFormData(state) {
  const formData = new FormData();
  formData.append('terminal_block_image', state.fileValue);
  return formData;
}
